import * as R from 'ramda'
import { t } from 'ttag'
import { categoryNames } from 'components/common/JobProfileWidget/text'
import { capitalizeFirstLetter } from 'utils/stringFormat'

import candidate_en from 'i18n/candidate_score_card.en.json'
import candidate_nb from 'i18n/candidate_score_card.nb.json'
import recruiter_en from 'i18n/recruiter_score_card.en.json'
import recruiter_nb from 'i18n/recruiter_score_card.nb.json'

export const languages = {
  en: {
    candidate: candidate_en,
    recruiter: recruiter_en,
  },
  nb: {
    candidate: candidate_nb,
    recruiter: recruiter_nb,
  },
}

const getCopy = (language, isCandidate) =>
  languages[language][isCandidate ? 'candidate' : 'recruiter']

export const scoreBucket = score => {
  if (score >= 0.7) return ['high', t`above average`]
  if (score >= 0.3) return ['mid', t`average`]

  return ['low', t`below average`]
}

export const prepText = traitName =>
  R.when(
    R.is(String),
    R.pipe(
      R.defaultTo('??'),
      R.replace(/\{ *trait *\}/g, traitName.toLowerCase()),
      R.replace(/\{ *Trait *\}/g, capitalizeFirstLetter(traitName)),
      R.split(/\s*\n\s*/),
      R.map(R.trim),
    ),
  )

export const getIntro = (language = 'en', isCandidate = false) =>
  getCopy(language, isCandidate).intro

export const getPersonality = (language = 'en', isCandidate = false) =>
  getCopy(language, isCandidate).personality

export const getTraitTranslation = (
  trait,
  score,
  language = 'en',
  isCandidate = false,
) => {
  const { label = '?', abstract, lowLabel, highLabel, ...text } = R.pathOr(
    {},
    [language, isCandidate ? 'candidate' : 'recruiter', 'traits', trait],
    languages,
  )

  const [bucket, judgement] = scoreBucket(score)

  const description =
    (isCandidate
      ? t`Your score in {trait} is ${judgement} `
      : t`The candidate's score in {trait} is ${judgement} `) +
    t`compared to other applicants who have completed the test. ` +
    (text[bucket] || '')

  return R.map(prepText(label))({
    label,
    score,
    abstract,
    lowLabel,
    highLabel,
    description,
    judgement,
  })
}

export const getTraitsTranslations = (
  traits,
  response,
  language = 'en',
  isCandidate = false,
) => {
  if (!traits || traits.length === 0) {
    return []
  }

  const traitsDefs = getCopy(language, isCandidate)['traits']

  return traits.map(trait => ({
    ...traitsDefs[trait],
    scores: response?.map(({ id, scores }) => ({
      id: id,
      score: Math.round(scores[trait] * 100),
    })),
    id: trait,
  }))
}

export const getCategoryKeys = categories => {
  return Object.keys(categories).filter(key => categories[key])
}

export const getVisibleCategory = (categoryKeys, scores, language) => {
  const categoriesDefs = categoryNames(language)

  return categoryKeys.map(key => ({
    score: Math.max(Math.min(Math.floor(scores[key] * 5), 4), 1),
    label: categoriesDefs[key][0],
  }))
}

export const getVisibleCategories = (categoryKeys, scores, language) => {
  const categoriesDefs = categoryNames(language)

  return scores.map(scores =>
    categoryKeys.map(key => ({
      score: Math.max(Math.min(Math.floor(scores[key] * 5), 4), 1),
      label: categoriesDefs[key][0],
    })),
  )
}
